import React from 'react';
import PropTypes from 'prop-types';
import { Drawer as MUIDrawer, makeStyles } from '@material-ui/core';
import { colors } from '../../../theme/color-palette';

const Drawer = ({ open, onClose, children, width }) => {
	const useStyles = makeStyles({
		paper: {
			width: width,
		},
	});

	const classes = useStyles();

	return (
		<MUIDrawer
			disableEnforceFocus
			anchor={'right'}
			open={open}
			elevation={1}
			onClose={onClose}
			PaperProps={{
				style: {
					boxShadow: '0px 0px 10px rgba(51, 51, 51, 0.1)',
				},
			}}
			classes={{ paper: classes.paper }}
			ModalProps={{
				BackdropProps: {
					style: {
						backgroundColor: colors.WHITE,
						opacity: '0.7',
					},
				},
			}}>
			{children}
		</MUIDrawer>
	);
};

Drawer.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	children: PropTypes.object,
	width: PropTypes.number,
};

export default Drawer;
